import styles from "./LoginForm.module.scss";
import { User, Lock } from "../../assets/icons";
import { CustomInput } from "../../shared/components/CustomInput";
import clsx from "clsx";
import { Button } from "../../shared/components/Button";
import { useState } from "react";
import { useAuthStore } from "../../shared/store/authStore";

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { login: authLogin, isLoading, error } = useAuthStore();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await authLogin(username, password);
  };
  return (
    <form className={clsx("form-frame", styles.form)} onSubmit={handleSubmit}>
      <CustomInput
        name="username"
        placeholder="Логин"
        icon={<User />}
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <CustomInput
        name="Пароль"
        placeholder="Пароль"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        icon={<Lock />}
      />
      {error && <p className={styles.error}>{error}</p>}
      <Button type="submit" disabled={isLoading} variant="wood">
        {isLoading ? "Вход..." : "Войти"}
      </Button>
    </form>
  );
};
export default LoginForm;
